import { Injectable } from '@angular/core';
import { CostCenter } from './cost-center.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface CostCentersState extends EntityState<CostCenter> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cost-centers' })
export class CostCentersStore extends EntityStore<CostCentersState> {

  constructor() {
    super();
  }

}

